import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hexagon, logoutIcon1 } from "../../../assets/constant";
import PaddingContainer from "../../../components/PaddingContainer";
import ToggleCommunity from "../../../components/ToggleCommunity";
import LogoutModal from "../../../modals/Logout";
import { logout } from "../../../store/authSlice";
import Shortcuts from "../Shortcuts";
import SidebarSkeleton from "../SidebarSkeleton";
import classes from "./ParentSkeleton.module.css";
import { fcmHandler } from "../../../store/FCMSlice";
import useLogin from "../../../Hooks/useLogin";
import Loader from "../../../components/Loader";
import { setWithdrawlAmount } from "../../../store/walletPaymentSlice";
import { setBeneficiary } from "../../../store/beneficiarySlice";

const ParentSkeleton = ({ children }) => {
  const sidebarAside = useRef(null);
  const { user } = useSelector((state) => state?.authReducer);
  const dispatch = useDispatch();
  const [isSidebarClose, setIsSidebarClose] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { logoutHandler, logoutLoader } = useLogin();

  const logoutFunction = () => {
    logoutHandler();

    dispatch(setWithdrawlAmount(0));
    dispatch(setBeneficiary(null))
    setShowModal(false);
  };

  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setIsSidebarClose(true);
    }
  };
  useEffect(() => {
    if (window.innerWidth <= 1024) {
      setIsSidebarClose(true);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const tagName = user?.userName?.split(" ")?.length > 1 ?
    user?.userName?.split(" ")[0]?.charAt(0) +
    user?.userName?.split(" ")[1]?.charAt(0) : user?.userName?.slice(0, 2);

  return (
    <>
      {
        logoutLoader ? <Loader /> :


          <div className={classes["sidebar__wrapper"]}>
            <Shortcuts
              setIsSidebarClose={() => setIsSidebarClose(!isSidebarClose)}
            />
            <div
              className={[
                classes["down-actions-wrapper"],
                isSidebarClose && classes["down-actions-sb-close"],
              ].join(" ")}
            >
              <div className={classes["down-actions"]}>
                
                <span>{tagName}</span>
                <img src={hexagon} />
                <div
                  className={classes["user-info"]}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                >
                  <p>{user?.userName}</p>
                  <p>{user?.emailAddress}</p>
                </div>
              </div>
              <div
                className={classes["logout-wrapper"]}
                onClick={() => setShowModal(true)}
              >
                <img src={logoutIcon1} />
              </div>
            </div>
            <div className={[classes["sidebar__mainContent"]].join(" ")}>
              <div className={classes["content-wrapper"]}>
                <SidebarSkeleton
                  isSidebarClose={isSidebarClose}
                  setIsSidebarClose={() => setIsSidebarClose(!isSidebarClose)}
                >
                  <PaddingContainer className={"h-100"}>
                    <ToggleCommunity />
                    {children}
                  </PaddingContainer>
                </SidebarSkeleton>{" "}
              </div>
            </div>
          </div>
      }
      <LogoutModal
        setShow={() => setShowModal(false)}
        show={showModal}
        handler={logoutFunction}
      />
    </>
  );
};

export default ParentSkeleton;
